const STORAGE_KEY = 'sigur_cs.reports.request_control'

export function emptyFilters() {
  return {
    period: { from: '', to: '' },
    territory_id: [],
    contractor_id: [],
    access_object_id: [],
    object_group_id: [],
    state: [],
    group_by: '',
  }
}

function normalizeFilters(raw) {
  if (!raw || typeof raw !== 'object') return null
  const base = emptyFilters()
  const period = raw.period || {}
  return {
    period: {
      from: period.from ? String(period.from) : '',
      to: period.to ? String(period.to) : '',
    },
    territory_id: Array.isArray(raw.territory_id)
      ? raw.territory_id.map((v) => parseInt(v, 10)).filter((n) => !Number.isNaN(n))
      : [],
    contractor_id: Array.isArray(raw.contractor_id)
      ? raw.contractor_id.map((v) => parseInt(v, 10)).filter((n) => !Number.isNaN(n))
      : [],
    access_object_id: Array.isArray(raw.access_object_id)
      ? raw.access_object_id.map((v) => parseInt(v, 10)).filter((n) => !Number.isNaN(n))
      : [],
    object_group_id: Array.isArray(raw.object_group_id)
      ? raw.object_group_id.map((v) => parseInt(v, 10)).filter((n) => !Number.isNaN(n))
      : [],
    state: Array.isArray(raw.state) ? raw.state.map(String).filter(Boolean) : [],
    group_by: raw.group_by ? String(raw.group_by) : '',
  }
}

export function filtersFromMeta(meta) {
  const filters = emptyFilters()
  const f = meta?.filters || {}
  if (f.period?.default) {
    filters.period = { ...f.period.default }
  }
  if (f.group_by?.default) {
    filters.group_by = f.group_by.default
  }
  if (f.contractor_id?.default?.length) {
    filters.contractor_id = [...f.contractor_id.default]
  }
  return filters
}

export function mergeCachedFilters(meta, cachedFilters) {
  const defaults = filtersFromMeta(meta)
  const cached = normalizeFilters(cachedFilters)
  if (!cached) return defaults
  return {
    ...defaults,
    period:
      cached.period.from && cached.period.to ? cached.period : defaults.period,
    territory_id: cached.territory_id,
    contractor_id: cached.contractor_id.length
      ? cached.contractor_id
      : defaults.contractor_id,
    access_object_id: cached.access_object_id,
    object_group_id: cached.object_group_id,
    state: cached.state,
    group_by: cached.group_by || defaults.group_by,
  }
}

export function filtersEqual(a, b) {
  return JSON.stringify(normalizeFilters(a)) === JSON.stringify(normalizeFilters(b))
}

export function loadRequestControlCache() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    return {
      filters: normalizeFilters(data.filters),
      appliedFilters: normalizeFilters(data.appliedFilters),
      summary: data.summary ?? null,
      displayMode: data.displayMode === 'detail' ? 'detail' : 'summary',
    }
  } catch {
    return null
  }
}

export function saveRequestControlCache(patch) {
  try {
    const prev = loadRequestControlCache() || {}
    const next = { ...prev, ...patch }
    if (patch.filters) next.filters = normalizeFilters(patch.filters)
    if (patch.appliedFilters) {
      next.appliedFilters = normalizeFilters(patch.appliedFilters)
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    /* quota / private mode */
  }
}

export function clearRequestControlCache() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
